import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminInbox from "@/pages/admin/AdminInbox";
import { AdminLayout, RequireAdmin } from "@/components/admin/AdminAuth";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<Home />} />
            <Route path="work" element={<Work />} />
            <Route path="services" element={<Services />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="admin" element={<AdminLayout />}>
            <Route path="login" element={<AdminLogin />} />
            <Route
              index
              element={
                <RequireAdmin>
                  <AdminInbox />
                </RequireAdmin>
              }
            />
          </Route>
        </Routes>
        <Toaster theme="dark" position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </MotionConfig>
  );
}

export default App;
